import {
    STROLLER_RATING_1, STROLLER_RATING_10, STROLLER_RATING_2, STROLLER_RATING_3, STROLLER_RATING_4,
    STROLLER_RATING_5, STROLLER_RATING_6, STROLLER_RATING_7, STROLLER_RATING_8, STROLLER_RATING_9,
} from 'mk/autogenerated/translations/helpers.d2044d2795d2bd293484aa4a0e47e225'
import { interpolate } from 'mk2/services/i18n';

export function translateScore(score: number) {
    return interpolate({
        1: STROLLER_RATING_1,
        2: STROLLER_RATING_2,
        3: STROLLER_RATING_3,
        4: STROLLER_RATING_4,
        5: STROLLER_RATING_5,
        6: STROLLER_RATING_6,
        7: STROLLER_RATING_7,
        8: STROLLER_RATING_8,
        9: STROLLER_RATING_9,
        10: STROLLER_RATING_10,
    }[score]);
}

export function capitalizeFirstLetter(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}
